angular
    .module('quattro.bmbo.account.form', [
        'quattro.core.config',
        'quattro.core.hpls-api-validation',
        'quattro.core.password-form',
        'quattro.core.user.service',
        'quattro.core.country-picker',
        'quattro.core.viewhelper',
        'quattro.bmbo.config',
        'quattro.bmbo.account.confirm-cancel',
        'quattro.bmbo.account.confirm-revoke-cancel',
        'quattro.bmbo.account.confirm-delete'
    ])
    .directive('bmboAccountForm', function () {
        return {
            restrict: 'E',
            scope: {
                data: '=',
                isCreate: '=?',
                cancel: '=',
                // will be called after successfull validation
                save: '=',
                section: '@?'
            },
            controller: 'bmboAccountFormController',
            controllerAs: 'vm',
            templateUrl: 'bmbo/account/account-form.html'
        };
    })
    .controller('bmboAccountFormController', function ($anchorScroll, $location, $scope, $window, userService, bmbo_account_plans, viewHelper, payment_types) {

        if ($scope.section) {
            $window.setTimeout(function () {
                $anchorScroll($scope.section);
            }, 1);
        }

        $scope.zahlungsarten = payment_types;

        $scope.$watch('data.payment_type', function (newValue, oldValue, scope) {
            scope.switchToDta = newValue === 'dta' && scope.data.$isDirty('payment_type');
        });

        this.user = userService.scope;
        this.plans = bmbo_account_plans;

        function gotoAccount() {
            $location.path('/account=' + this);
        }

        this.save = function () {
            if (viewHelper.formIsValid()) {
                $scope.save();
            }
        };

        this.accountCancel = function (account) {
            $scope.$emit('vq.bmbo.account.cancel', account, gotoAccount.bind(account));
        };

        this.accountRevokeCancel = function (account) {
            $scope.$emit('vq.bmbo.account.revoke-cancel', account, gotoAccount.bind(account));
        };

        this.accountDelete = function (account) {
            $scope.$emit('vq.bmbo.account.delete', account, gotoAccount.bind(account));
        };

    });
